<template>
<div class='login-view login-form'>
  <h1>{{$t('actions.login.title')}}</h1>

  <el-form ref="form" :model='form' :rules="rules">
    <el-form-item prop='emailOrCellphone' :error="errors.first('emailOrCellphone')">
      <el-input v-model="form.emailOrCellphone" name='ppj-account' :placeholder="$t('placeholder.user.emailOrCellphone')">
      </el-input>
    </el-form-item>

    <el-form-item prop='password' :error="errors.first('password')">
      <el-input v-model="form.password" type='password' :placeholder="$t('placeholder.user.password')">
      </el-input>
    </el-form-item>

    <el-form-item>
      <el-button @click.native="signIn" type="primary submit-btn">{{$t('actions.login.login')}}</el-button>
    </el-form-item>

    <el-form-item>
      <div class='left'>
        <router-link to="/wxlogin">
          <i class='ppj-icon-wechat' style='margin-right: 0.5em;'></i> {{$t('actions.login.wxlogin')}}
        </router-link>
      </div>
      <div class='right'>
        <router-link to="/register">{{$t('actions.login.register')}}</router-link>&nbsp;|
        <router-link to="password">{{$t('actions.login.password')}}</router-link>
      </div>
    </el-form-item>
  </el-form>
</div>
</template>

<script>
import Validator from '@/mixins/validator'

export default {
  data() {
    return {
      form: {
        emailOrCellphone: null,
        password: null
      }
    }
  },
  mixins: [Validator],
  rules: {
    required: ['emailOrCellphone', 'password']
  },
  methods: {
    signIn() {
      let vm = this

      let p1 = new Promise((resolve, reject) => {
        vm.errors.clear()
        vm.$refs['form'].validate(res => {
          res ? resolve() : reject('form')
        })
      })

      p1.then(_ => {
        vm.$store.dispatch('user/signIn', {
          login: vm.form.emailOrCellphone,
          password: vm.form.password
        }).then(_ => {
          vm.$router.push({
            path: '/'
          })
        }).catch(err => {
          let data = err.response.data

          if (data.type === 'PasswordIncorrectError') {
            vm.errors.add('password', data.message)
          } else if (data.type === 'EmailOrPhoneNotExistError') {
            vm.errors.add('emailOrCellphone', data.message)
          }
        })
      }).catch(err => {
        console.log('未通过前端验证', err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// login.view.vue?24cec807